import '@fontsource/plus-jakarta-sans/latin-400.css';
import '@fontsource/plus-jakarta-sans/latin-600.css';
import '@fontsource/plus-jakarta-sans/latin-700.css';
import '@fontsource/plus-jakarta-sans/latin-800.css';
/**
 * Startpunt van de tablet-app.
 *
 * Geen StrictMode: die roept effecten in ontwikkeling twee keer aan, en dat maakt
 * het pollritme in useRooster onnodig lastig te volgen bij het debuggen van een
 * verversprobleem — precies waar je die logica wil kunnen vertrouwen. De app heeft
 * geen legacy-patronen waar StrictMode voor waarschuwt.
 */
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

const houder = document.getElementById('app');
if (!houder) throw new Error('Element #app ontbreekt in index.html');

createRoot(houder).render(<App />);
